import React, { useState } from 'react';
import CreateProjectContent from './AppLayout/CreateProjectContent/CreateProjectContent';
import './CreateProject.scss';
import ProjectSuccessContent from './AppLayout/ProjectResultContent/ProjectResultContent';
import { Product } from '../../../data/terra/Product';

const CreateProject: React.FC = () => {
  const [project, setProject] = useState<Product>();

  const onCreateProjectSuccess = (project: Product) => {
    setProject(project);
  };

  return project ? (
    <ProjectSuccessContent project={project} />
  ) : (
    <CreateProjectContent onCreateProjectSuccess={onCreateProjectSuccess} />
  );
};

export default CreateProject;
